export default "__VITE_ASSET__CELwMcwV__ 600w, __VITE_ASSET__dYvYDG9U__ 900w, __VITE_ASSET__B0_yfKQX__ 1200w";